// extracted by mini-css-extract-plugin
export default {"root":"UsersTable_root__DHrcn","row":"UsersTable_row__RZc7C","boxMargin":"UsersTable_boxMargin__vOEXB","fullHeight":"UsersTable_fullHeight__XCUdq"};